import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=41f82610&scoped=true&"
import script from "./GroupList.vue?vue&type=script&lang=js&"
export * from "./GroupList.vue?vue&type=script&lang=js&"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=41f82610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f82610",
  null
  
)

export default component.exports